import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import { useGetAccounts } from '@vindr/services/actions/account.action';
import keycloak from '@vindr/services/keycloak';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectFilter from '../templates/SelectFilter';

interface ShareBy extends Omit<SelectFilter, 'title' | 'placeholder' | 'options'> {
  institutions?: string[];
  title?: SelectFilter['title'];
  placeholder?: SelectFilter['placeholder'];
  options?: SelectFilter['options'];
}

const ShareBy = ({ title, value, onChange, institutions, placeholder, width }: ShareBy) => {
  const { t } = useTranslation('Vindoc');
  placeholder = placeholder || t('Share By');

  const isSuperAdmin = keycloak.isSuperAdmin();
  const userInfo = keycloak.getUserInfo();

  const { data, isLoading } = useGetAccounts({
    offset: 0,
    limit: 100,
    ...(!isSuperAdmin && {
      institutions: isEmpty(institutions) ? userInfo?.institutions : institutions,
    }),
  });
  const accounts = data?.data;

  const options = useMemo(
    () =>
      accounts?.map((item) => ({
        value: item?.id,
        label: item?.fullname || item?.username,
      })),
    [accounts]
  );

  return (
    <SelectFilter
      loading={isLoading}
      {...{ width, options, title, value, onChange }}
      disabled={!keycloak.hasOneOfPerm([PERMISSIONS.page.admin_settings])}
      placeholder={placeholder}
      searchVietnamese
      mode="multiple"
    />
  );
};

export default ShareBy;
